import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";
const adminToken = secureStorage.getItem("adminToken");

export const addHotel = (FormData, navigate) => {
  axiosInstance
    .post("/hotel/add", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Hotel added successfully") {
        toast.success("Hotel added");
        navigate("/admin/hotels");
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      if (err.response) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Something went wrong");
      }
    });
};
export const getHotelList = (setHotelData, Page, Limit, setPageData) => {
  axiosInstance
    .get(`/hotel/list?page=${Page}&limit=${Limit}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setHotelData(res.data.data);
      setPageData(res.data.totalPages);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const getSingleHotel = (
  id,
  setFormData,
  setImageFile,
  setCompanyId,
  setSelectNearBy,
) => {
  axiosInstance
    .get(`/hotel/get/${id}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data) {
        setTimeout(() => {
          setFormData({
            hotelId: res.data.id,
            companyId: res.data.companyId,
            hotelName: res.data.hotelName,
            hotelLogo: res.data.hotelLogo,
            propertyStar: res.data.propertyStar,
            description: res.data.description,
            rooms: res.data.rooms,
            floors: res.data.floors,
            foundedYear: res.data.foundedYear,
            area: res.data.area,
            city: res.data.city,
            division: res.data.division,
            country: res.data.country,
            isCoupleFriendly: res.data.isCoupleFriendly,
            isFeatured: res.data.isFeatured,
            isIdRequired: res.data.isIdRequired,
            checkIn: res.data.checkIn,
            checkOut: res.data.checkOut,
            isChildAllowed: res.data.isChildAllowed,
            childPolicy: res.data.childPolicy,
            isPetAllowed: res.data.isPetAllowed,
            petPolicy: res.data.petPolicy,
            hotelRules: res.data.hotelRules,
            isAcceptMasterCard: res.data.isAcceptMasterCard,
            isAcceptVisaCard: res.data.isAcceptVisaCard,
            isAcceptDebitCard: res.data.isAcceptDebitCard,
            isAcceptAmmexCard: res.data.isAcceptAmmexCard,
            isAcceptCash: res.data.isAcceptCash,
            isAcceptsMFS: res.data.isAcceptsMFS,
            isDhoorbinChoice: res.data.isDhoorbinChoice,
            isCustomerChoice: res.data.isCustomerChoice,
            status: res.data.status,
            advancePayment: res.data.advancePayment,
            created_by: res.data.created_by,
            createdAt: res.data.createdAt,
            facilities: res.data.facilities,
            images: res.data.images,
            nearBy: res.data.nearBy,
            countryId: res.data.countryId,
            divisionId: res.data.divisionId,
            cityId: res.data.cityId,
          });
          setImageFile(res.data.images);
          setCompanyId(res.data.companyId);
          setSelectNearBy(res.data.nearBy);
        }, 20);
      }
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};
export const updateHotel = (FormData, navigate) => {
  axiosInstance
    .put("/hotel/update", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Hotel updated successfully") {
        toast.success("Hotel updated");
        navigate("/admin/hotels");
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      if (err.response) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Something went wrong");
      }
    });
};

export const deleteHotel = (setHotelData, setPageData, Page, Limit, id) => {
  axiosInstance
    .delete(`/hotel/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Hotel and related data deleted successfully") {
        toast.success("Hotel deleted");
        getHotelList(setHotelData, Page, Limit, setPageData);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};
export const allHotels = (setData) => {
  axiosInstance
    .get("/hotel/hotels", {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setData(res.data.data);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const allCustomers = (setData) => {
  axiosInstance
    .get("/users/all-customers", {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setData(res.data.data);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const registerUser = (FormData, setFormData, setData) => {
  axiosInstance
    .post("/users/register", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.success) {
        toast.success(res.data.message);
        setFormData({
          fullName: "",
          email: "",
          phoneNumber: "",
          password: "123456",
          isCustomer: 1,
          isWelcomed: 1,
          status: 1,
          createdAt: new Date().toISOString(),
        });

        allCustomers(setData);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error(err?.response?.data?.message || "Something went wrong");
    });
};
export const getAllRooms = (setData, hotelId) => {
  axiosInstance
    .get(`/hotel/get-rooms/${hotelId}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setData(res.data.data);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const hotelBooking = (
  setHotelData,
  Page,
  Limit,
  setPageData,
  setIsLoading,
) => {
  setIsLoading(true);
  axiosInstance
    .get(`/order/hotel/all?page=${Page}&limit=${Limit}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setHotelData(res.data.data);
      setPageData(res.data.totalPage);
      setIsLoading(false);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const deleteHotelbooking = (
  setHotelData,
  Page,
  Limit,
  setPageData,
  setIsLoading,
  id,
) => {
  setIsLoading(true);
  axiosInstance
    .delete(`/order/hotel/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      toast.success("Invoice Deleted");
      hotelBooking(setHotelData, Page, Limit, setPageData, setIsLoading);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const tourBookings = (
  setTourData,
  Page,
  Limit,
  setPageData,
  setIsLoading,
) => {
  setIsLoading(true);
  axiosInstance
    .get(`/order/tour/all?page=${Page}&limit=${Limit}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setTourData(res.data.data);
      setPageData(res.data.totalPage);
      setIsLoading(false);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const deleteTourOrder = (
  setTourData,
  Page,
  Limit,
  setPageData,
  setIsLoading,
  id,
) => {
  axiosInstance
    .delete(`/order/tour/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Tour deleted successfully") {
        toast.success("Tour deleted");
        tourBookings(setTourData, Page, Limit, setPageData, setIsLoading);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};
export const hotelBookingReport = (
  setData,
  StartDate,
  EndDate,
  SelectedHotel,
  SelectedCustomer,
  setIsLoading,
) => {
  setIsLoading(true);
  axiosInstance
    .get(
      `/order/hotel/report/hotel?hotelId=${SelectedHotel}&orderedBy=${SelectedCustomer}
&fromDate=${EndDate ? StartDate : ""}
&toDate=${StartDate ? EndDate : ""}`,
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      },
    )
    .then((res) => {
      setData(res.data.data);

      setIsLoading(false);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const getMetaData = (setHotels, setCustomers, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .get(`/order/hotel/meta-data`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setHotels(res.data.hotels);
      setCustomers(res.data.customers);

      setIsLoading(false);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const requestHotelBooking = (
  SelectedCustomer,
  SelectedHotel,
  FormData,
  setIsLoading,
) => {
  setIsLoading(true);
  axiosInstance
    .post(
      "/hotel/create-hotel-booking",
      {
        bookedby: SelectedCustomer,
        hotelInfo: SelectedHotel,
        FormData: FormData,
      },
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      },
    )
    .then((res) => {
      if (res.data.message === "Hotel order created successfully") {
        toast.success(res.data.message);
        setIsLoading(false);
      } else {
        toast.error(res.data.message);
        setIsLoading(false);
      }
    })
    .catch((err) => {
      toast.error(err?.response?.data?.message || "Something went wrong");
      setIsLoading(false);
    });
};
export const makeitPaid = (
  invoiceId,
  paidAmount,
  setHotelData,
  Page,
  Limit,
  setPageData,
  setIsLoading,
) => {
  setIsLoading(true);
  axiosInstance
    .put(
      `/order/hotel/update-paid/${invoiceId}`,
      {
        paidAmount: paidAmount,
      },
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      },
    )
    .then((res) => {
      if (res.data.message === "paidAmount updated successfully") {
        toast.success(res.data.message);
        hotelBooking(setHotelData, Page, Limit, setPageData, setIsLoading);
        setIsLoading(false);
      } else {
        toast.error(res.data.message);
        setIsLoading(false);
      }
    })
    .catch((err) => {
      toast.error(err?.response?.data?.message || "Something went wrong");
    });
};
// Add these to src/api/admin/hotel.js (same axiosInstance + imports the other calls use).

export const getOrderDetails = async (id, setData, setLoading) => {
  const adminToken = secureStorage.getItem("adminToken");
  try {
    setLoading && setLoading(true);
    const res = await axiosInstance.get(`/order/hotel/details/${id}`, {
      headers: { Authorization: `Bearer ${adminToken}` },
    });
    setData(res.data);
  } catch (err) {
    console.error(err);
    toast.error(err?.response?.data?.message || "Failed to load order");
  } finally {
    setLoading && setLoading(false);
  }
};

export const updateOrderStatus = async (id, status, onDone) => {
  const adminToken = secureStorage.getItem("adminToken");
  try {
    const res = await axiosInstance.put(
      `/order/hotel/status/${id}`,
      { status },
      {
        headers: { Authorization: `Bearer ${adminToken}` },
      },
    );
    toast.success(res.data?.message || "Status updated");
    onDone && onDone(res.data);
  } catch (err) {
    console.error(err);
    toast.error(err?.response?.data?.message || "Failed to update status");
  }
};
